export default "__VITE_ASSET__2ea204d6__"